import React from 'react';

const News = () => {
    return (
        <div>
            <div className="clear"/>
            <div className="modulesLR moduleBrown">
                <div className="body-l">
                    <div className="body-r">
                        <ul className="list_news">
                            <li>
                                <a href="/">Có
                                    gì mới trong phiên bản này</a>
                            </li>
                            <li>
                                <a href="/">Hướng
                                    dẫn đăng ký thành viên, in vé dò
                                    và bán xổ số online</a></li>
                            <li>
                                <a href="/">Hướng
                                    Dẫn In Vé Dò Kết Quả Xổ Số</a>
                            </li>
                            <li>
                                <a href="/">IN
                                    VÉ DÒ TRÊN CHROME</a></li>
                            <li>
                                <a href="/">IN
                                    VÉ DÒ TRÊN FIREFOX</a></li>
                            <li>
                                <a href="/">Lấy
                                    kết quả xổ số về websites của
                                    bạn</a></li>
                            <li>
                                <a href="/">THIẾT
                                    LẬP KHỔ GIẤY A4</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="clear"/>
        </div>
    );
};

export default News;
